<ng-container *ngIf="taxonomies$ | async as taxonomies">
    <ng-container *ngFor="let taxonomy of taxonomies; let last = last">
        <a [href]="taxonomy.link.url" target="_blank">
            <ng-container *ngIf="!taxonomy.title"> {{ taxonomy.link.url }} </ng-container>
            {{ taxonomy.title }}
        </a>
        <span *ngIf="taxonomies.length > 1 && !last">,&nbsp;</span>
    </ng-container>
</ng-container>
